//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import _ from "lodash";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { postureModalIpad} from "../assets/lang.conf/root";
export default {
  name: "Posture_modal_ipad",
  i18n: {
    // `i18n` option, setup locale info for component
    messages: {
      ...postureModalIpad
    }
  },
  directive: {
    bModalDirective
  },
  components: {},
  props: ["modalInfo"],
  data() {
    return {
      level: {
        normal: "normal",
        mild: "mild",
        severe: "severe"
      }
    };
  },
  computed: {},
  methods: {
    getRiskImg(risk) {
      let direction = "normal";
      let img;
      console.log(risk.key);
      if (
        !_.isNull(risk.direction) &&
        risk.key !== "legO" &&
        risk.key !== "legX" &&
        risk.key !== "legXO" &&
        risk.key !== "kneeOverstretch"
      ) {
        direction = risk.direction;
      }
      if (this.checkIfAbnormal(risk.level)) {
        img = risk.abnormal[direction];
      } else {
        img = risk.normal[direction];
      }
      return img;
    },
    checkIfAbnormal(level) {
      switch (level) {
        case this.level.normal:
          return false;
        case this.level.mild:
          return false;
        case this.level.severe:
          return true;
      }
    },
    show() {},
    hideModal() {
      this.$emit("hideModal");
    },
    initRiskBar() {
      this.$emit("initRiskBar");
    },
    getLevel(level) {
      switch (level) {
        case this.level.normal:
          return {
            des: "正常",
            className: "level-normal"
          };
        case this.level.mild:
          return {
            des: "潜在风险",
            className: "level-mild"
          };
        case this.level.severe:
          return {
            des: "高风险",
            className: "level-severe"
          };
      }
    }
  },
  created() {}
};



// WEBPACK FOOTER //
// ./src/components/Posture_modal_ipad.vue